// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__5kR6+","group":"Sidebar_group__imvm+","groupTitle":"Sidebar_groupTitle__rjh19","link":"Sidebar_link__EWaBV","active":"Sidebar_active__dDJqk"};